import type { BaseEntity } from 'core/base';
import type { TreeNode } from '../types';
import { StyledTitle } from '../Finder.styles';

export const defaultTitleRender = <TEntity extends BaseEntity>(node: TreeNode<TEntity>) => {
  const { addonBefore, addonAfter, title, docState, hasError } = node;

  const _className = `w-100 ${hasError ? 'error' : ''}`;

  return (
    <StyledTitle data-test-id={docState?.document?._id}>
      {addonBefore || null}

      <span className={_className}>{title}</span>

      {addonAfter || null}
    </StyledTitle>
  );
};
